import React, { useState } from "react";

export default function ReligiousForm() {
  const [form, setForm] = useState({
    state: "",
    city: "",
    pax: "",
    child: 0,
    childAges: [],
    hotelCategory: "",
    phone: "",
    email: "",
    travelDate: "",
    nights: "",
    text: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });

    if (e.target.name === "child") {
      const count = parseInt(e.target.value) || 0;
      setForm((prev) => ({
        ...prev,
        childAges: Array(count).fill(""),
      }));
    }
  };

  const handleChildAgeChange = (index, value) => {
    const updated = [...form.childAges];
    updated[index] = value;
    setForm({ ...form, childAges: updated });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Final Form:", form);
    alert("Form submitted!");
  };

  return (
    <div className="flex justify-center items-center py-10 px-3 ">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-3xl bg-gradient-to-br from-teal-400 via-cyan-500 to-blue-500 shadow-2xl rounded-xl p-8 border border-gray-200"
      >
        {/* Title */}
        <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
          ✈️ Religious Travel Enquiry
        </h2>

        {/* Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

          {/* Domestic */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Travel Type
            </label>
            <input
              className="w-full p-3 rounded-lg bg-gray-100 border"
              value="Religious"
              disabled
            />
          </div>

          {/* Country */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Country
            </label>
            <input
              className="w-full p-3 rounded-lg bg-gray-100 border"
              value="India"
              disabled
            />
          </div>

          {/* State */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              State
            </label>
            <input
              type="text"
              name="state"
              value={form.state}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg"
              placeholder="Enter state"
            />
          </div>

          {/* City */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              City
            </label>
            <input
              type="text"
              name="city"
              value={form.city}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg"
              placeholder="Enter city"
            />
          </div>

          {/* Pax */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              No. of Adults
            </label>
            <input
              type="number"
              name="pax"
              value={form.pax}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg"
              placeholder="Enter adult count"
              required
            />
          </div>

          {/* Children */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              No. of Children
            </label>
            <input
              type="number"
              name="child"
              value={form.child}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg"
              min="0"
              placeholder="Enter child count"
            />
          </div>

          {/* Dynamic Child Ages */}
          {form.child > 0 &&
            form.childAges.map((age, index) => (
              <div key={index} className="md:col-span-2">
                <label className="block text-gray-700 font-medium mb-1">
                  Child {index + 1} Age
                </label>
                <input
                  type="number"
                  value={age}
                  className="w-full p-3 border rounded-lg"
                  onChange={(e) =>
                    handleChildAgeChange(index, e.target.value)
                  }
                  placeholder="Enter age"
                />
              </div>
            ))}

          {/* Hotel Category */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Hotel Category
            </label>
            <select
              name="hotelCategory"
              value={form.hotelCategory}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg"
            >
              <option value="">Select Category</option>
              <option value="2 Star">⭐ 2 Star</option>
              <option value="3 Star">⭐ 3 Star</option>
              <option value="4 Star">⭐ 4 Star</option>
              <option value="5 Star">⭐ 5 Star</option>
            </select>
          </div>

          {/* Phone */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Phone Number
            </label>
            <input
              type="text"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg"
              placeholder="Enter phone"
              required
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Email ID
            </label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg"
              placeholder="Enter email"
              required
            />
          </div>

          {/* Travel Date */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Travel Date
            </label>
            <input
              type="date"
              name="travelDate"
              value={form.travelDate}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg"
              required
            />
          </div>

          {/* Nights */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Nights
            </label>
            <input
              type="number"
              name="nights"
              value={form.nights}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg"
              placeholder="Enter nights"
              required
            />
          </div>

          {/* Notes - Full Width */}
          <div className="md:col-span-2">
            <label className="block text-gray-700 font-medium mb-1">
              Notes (Optional)
            </label>
            <textarea
              name="text"
              value={form.text}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg h-24"
              placeholder="Any special requests?"
            />
          </div>
        </div>

        {/* Submit Button */}
        <button
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold p-3 rounded-lg mt-6 transition-all duration-200"
        >
          Submit Enquiry
        </button>
      </form>
    </div>
  );
}
